
import BookingTimeItem from '~/components/booking/BookingTimeItem'

export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    components: {
        BookingTimeItem
    }
}
